<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <v-row align="center" justify="center" dense no-gutters>
            <template v-for="image in value" >
                <v-col ref="parent" style="position:relative;" class="pa-0" :key="image.no" cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
                    <v-card outlined class="ma-1" @click="onClickImage(image)">
                        <v-card-text class="pa-1">
                            <v-img
                                ref="base_image"
                                v-if="image.state == 4"                                        
                                :src="image.image"
                                aspect-ratio="1"
                                contain>
                            </v-img>
                            <v-img
                                ref="base_image"
                                v-if="image.state == 2"
                                :src="image.image" 
                                aspect-ratio="1"
                                contain>
                            </v-img>
                            <v-img
                                ref="base_image"
                                v-if="image.state == 1"                                        
                                :src="image.url" 
                                aspect-ratio="1"
                                contain>
                            </v-img>
                            <div>
                                <template v-if="image.comments != null">
                                    <template v-for="comment in image.comments">
                                        <v-img
                                            v-if="comment.visible"
                                            :key="comment.dateTime"
                                            :src="comment.image"
                                            aspect-ratio="1"
                                            style="position:absolute; top:0px; left:0px; width:100%; height:100%"
                                            contain />
                                    </template>
                                </template>
                            </div>
                        </v-card-text>
                    </v-card>
                    <v-card outlined class="ma-1" v-if="enableDelete || enableImageComment">
                        <template v-if="image.comments != null && image.comments.length > 0 && enableImageComment">
                            <span style="font-size:small" class="ml-1">{{image.comments.length}}件の画像コメント</span><br/>
                        </template>
                        <v-btn v-if="enableDelete" icon color="primary" @click.stop="onClickDeleteImage(image)"><v-icon large>mdi-delete-circle-outline</v-icon></v-btn>
                        <v-btn v-if="enableImageComment" icon color="primary" @click.stop="onClickCommentToImage(image)"><v-icon large>mdi-comment-edit-outline</v-icon></v-btn>
                    </v-card>
                </v-col>
            </template>
        </v-row>
        <v-row v-if="enableImport">
            <v-col>
                <ImageImporter @onImportedImage="onImportedImage" @onImportedUncategorizedImages="onImportedUncategorizedImages" enabledUncategorizedImageSelect/>
            </v-col>
        </v-row>
        <ImageViewer ref="imageViewer" />
        <ImageEditor ref="imageEditor" @onAddImageComment="onAddImageComment" />
        <Confirm ref="confirm" />
    </v-container>
</template>

<script>
    import ImageImporter from '@/components/tools/ImageImporter';
    import ImageViewer from '@/components/tools/ImageViewer';
    import ImageEditor from '@/components/tools/ImageEditorDialog';
    import Confirm from '@/components/tools/ConfirmDialog';

    export default {
        components: {
            ImageImporter,
            ImageViewer,
            ImageEditor,
            Confirm
        },
        props: {
            /**
             * v-model(画像設定の配列)
             */
            value: {
                type: Array,
                default: function () {
                    return []
                }
                    // {
                    //     no: 1,
                    //     state: 1,
                    //     image: "",
                    //     url: "",
                    //     capturedDate: ""
                    // }
            },
            /** 画像取り込みを有効とするか否か */
            enableImport: {
                type: Boolean,
                default: true
            },
            /** 画像の削除を有効とするか否か */
            enableDelete: {
                type: Boolean,
                default: true
            },
            /** 画像コメント機能を有効とするか否か */
            enableImageComment: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            /**
             * 画像押下時
             */
            onClickImage: function (image) {
                console.log(image)
                this.$refs.imageViewer.show(image)
            },
            /**
             * 削除ボタン押下時
             */
            onClickDeleteImage: function (image) {
                const self = this
                this.$refs.confirm.show({
                    title: "削除",
                    message: "この写真を削除して宜しいですか？",
                    width: 400,
                    icon: "mdi-alert",
                    buttonYes: "削除する",
                    buttonNo: "しない",
                    listenerYes: function () {
                        switch (image.state) {
                            case 1:
                                image.state = 3
                                break
                            case 2:
                                const index = self.value.findIndex((v) => v.no === image.no)
                                self.value.splice(index, 1)
                                break
                        }
                        return true
                    },
                })
            },
            /**
             * 画像へのコメントボタン押下時
             */
            onClickCommentToImage: function (image) {
                console.log("Images", "onClickCommentToImage", image)
                const editorParams = {
                    originalImage: image,
                    title: "画像へのコメント記入",
                    baseImage: "",
                    layers: [],
                    readOnly: false,
                    canAddLayer: false,
                    createNewLayerWhenStart: true,
                }
                if (image.url != "") {
                    editorParams.baseImage = image.url
                } else if (image.image != "") {
                    editorParams.baseImage = image.image
                }
                for (var i=0; i<image.comments.length; i++) {
                    const layer = {
                        srcImage: image.comments[i].image,
                        visible: image.comments[i].visible,
                        name: image.comments[i].dateTime,
                        canDelete: true,
                        canEdit: true,
                        commentData: image.comments[i]
                    }
                    editorParams.layers.push(layer)
                }
                this.$refs.imageEditor.show(editorParams)
            },
            /**
             * 画像へのコメントが行われた時
             */
            onAddImageComment: function (params) {
                const self = this
                params.originalImage.comments.splice(0, params.originalImage.comments.length)
                params.layers.forEach(function(layer){
                    const commentData = {
                        image: layer.image,
                        visible: layer.params.visible,
                        dateTime: ""
                    }
                    if (layer.params.commentData != null) {
                        commentData.dateTime = layer.params.commentData.dateTime
                    } else {
                        commentData.dateTime = self.df_currentDateTime()
                    }
                    console.log(commentData)
                    params.originalImage.comments.splice(0, 0, commentData) //.push(commentData)
                })
                this.$emit("onCommentImage", params.originalImage)
            },
            /**
             * 画像取り込み時(カメラorローカル)
             */
            onImportedImage: function (image) {
                console.log("onImportedImage")
                var newNo = 1
                if (this.value.length > 0) {
                    newNo = Math.max(...this.value.map(m => m.no)) + 1
                }
                this.value.push({
                    no: newNo,
                    state: 2,
                    image: image,
                    url: "",
                    capturedDate: this.df_currentDateTime(),
                    comments: []
                })
                console.log(this.value)
            },
            /**
             * 未分類の撮影画像取り込み時
             */
            onImportedUncategorizedImages: function (images) {
                console.log("onImportedUncategorizedImages", images)

                const self = this

                //　参考 >> https://hi0a.com/demo/-js/img-base64-datauri/
                const Base64Converter = function(){
                    // URLからファイルを取得
                    this.loadBinaryResource = function(url) {
                        var req = new XMLHttpRequest();
                        req.open('GET', url, false);
                        req.overrideMimeType('text/plain;charset=x-user-defined');
                        req.send(null);
                        if (req.status != 200) return '';
                        return req.responseText;
                    }
                
                    // バイナリデータを文字列に変換
                    this.convertBinaryFile = function(url) {
                        var filestream = this.loadBinaryResource(url);
                        var bytes = [];
                        for (var i = 0; i < filestream.length; i++){
                            bytes[i] = filestream.charCodeAt(i) & 0xff;
                        }
                        // return String.fromCharCode.apply(String, bytes);
                        var result = ""
                        for (var i=0; i<bytes.length; i++) {
                            result += String.fromCharCode(bytes[i])
                        }
                        return result
                    }
                
                    // バイト文字列をbase64文字列に変換
                    this.convertImgDataURL = function(url){
                        var binary_file = this.convertBinaryFile(url);
                        var base64 = btoa(binary_file);
                        var head = binary_file.substring(0,9);
                        var exe = this.checkExe(head);
                        return 'data:image/' + exe + ';base64,' + base64;
                    }
                
                    // バイナリの拡張子をチェック
                    this.checkExe = function(head){
                        if (head.match(/^\x89PNG/)) {
                            return 'png';
                        } else if (head.match(/^BM/)){
                            return 'bmp';
                        } else if (head.match(/^GIF87a/) || head.match(/^GIF89a/)) {
                            return 'gif';
                        } else if (head.match(/^\xff\xd8/)) {
                            return 'jpeg';
                        } else {
                            return false;
                        }
                    }
                }

                var newNo = 1

                if (this.value.length > 0) {
                    newNo = Math.max(...this.value.map(m => m.no)) + 1
                }

                const converter = new Base64Converter()

                console.log(converter)

                images.forEach(function(image){
                    console.log("image", image)

                    // まだ取り込まれていないイメージか否かをチェックし、取り込まれていなければ取り込む
                    if (self.value.findIndex((v)=>v.state == 4 && v.source.imageID == image.imageID) < 0) {
                        const item = {
                            no: newNo,
                            state: 4,
                            image: converter.convertImgDataURL(image.image.url),
                            url: "",
                            capturedDate: image.image.capturedDateTime,
                            source: image
                        }

                        console.log(item)

                        self.value.push(item)

                        newNo++
                    }
                })
            },
        }
    }
</script>
